import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { MessagePanelComponent } from "@components/message-panel/message-panel.component";
import { SimpleSelectorComponent } from "@components/simple-selector/simple-selector.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { IMessageModel, MessageSeverity } from "~app/common/components/message-panel/message-panel.models";
import { Atgard } from "~app/features/virkeskop/models/atgard-models";
import { Avverkningsanmalan } from "~app/features/virkeskop/models/avverkningsanmalan-models";

@Component({
    selector: "rask-atgard-typ-dialog",
    templateUrl: "./atgard-typ-dialog.component.html",
    styleUrl: "./atgard-typ-dialog.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MessagePanelComponent,
        SimpleSelectorComponent,
        ButtonComponent
    ]
})
export class AtgardTypDialogComponent implements OnInit {
    modal = inject(NgbActiveModal);

    @Input() atgard: Atgard;
    @Input() atgardsTyper: any[];
    @Input() avverkningsAnmalan: Avverkningsanmalan;

    protected canSave = false;
    protected messages: IMessageModel[] = [];

    private atgardsTyp: string;

    ngOnInit(): void {
        this.atgardsTyp = this.atgard.atgardstyp;

        this.handleWarnings();
    }

    protected save() {
        this.modal.close(this.atgardsTyp);
    }

    protected close() {
        this.modal.dismiss();
    }

    protected typSelected(typ: string): void {
        this.canSave = false;

        if (this.atgard.atgardstyp !== typ) {
            this.atgardsTyp = typ;
            this.canSave = true;
        }
    }

    private handleWarnings(): void {
        if(this.avverkningsAnmalan?.godkantDatum) {
            const godkantDatum = moment(this.avverkningsAnmalan.godkantDatum.toString());
            const dagensDatum = moment();

            const diff = dagensDatum.diff(godkantDatum, "days");

            const message = {
                severity: MessageSeverity.Warning
            } as IMessageModel;

            if (diff > 42) {
                message.message = `Då det gått mer än sex veckor sedan godkännandet måste en ny avverkningsanmälan göras.
                                Om du ändrar typ och sparar kommer information om avverkningsanmälan att rensas i Rask.`;
            } else {
                message.message = "Vid byte av åtgärdstyp kan en komplettering av avverkningsanmälan behövas!";
            }

            this.messages.push(message);
        }
    }
}
